import { render, staticRenderFns } from "./PUserLocations.vue?vue&type=template&id=28b693c2&scoped=true"
import script from "./PUserLocations.vue?vue&type=script&lang=js"
export * from "./PUserLocations.vue?vue&type=script&lang=js"
import style0 from "./PUserLocations.vue?vue&type=style&index=0&id=28b693c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b693c2",
  null
  
)

export default component.exports